import { defineMessages } from 'react-intl';
import { VEHICLE_PURCHASE_SERVICES_NAMES } from '../names/_vehiclePurchaseServices.names';

const intlPrefix =
  'app.dealer.account.DealerProfileSettings.ServicesPanel.services.intl.vehiclePurchaseServices';

/**
 * @typedef {import('../names/_vehiclePurchaseServices.names').VEHICLE_PURCHASE_SERVICES} VehiclePurchaseServicesNames
 * @typedef {Record<VehiclePurchaseServicesNames, {id: string, defaultMessage: string}>} VehiclePurchaseServicesNamesIntl
 */

/**
 * `defineMessages` is used by `react-intl`. It is just a function that returns the object it's passed.
 * `react-intl` needs it to comply with babel-plugin-react-intl and i18n message extraction.
 *
 * @description
 * vehicle purchase services intl text
 *
 * @const vehiclePurchaseServicesIntl
 * @type {VehiclePurchaseServicesNamesIntl}
 */
export const vehiclePurchaseServicesIntl = defineMessages({
  [VEHICLE_PURCHASE_SERVICES_NAMES.VEHICLE_FINANCING]: {
    id: `${intlPrefix}.vehicleFinancing`,
    defaultMessage: 'Fahrzeugfinanzierung',
  },
  [VEHICLE_PURCHASE_SERVICES_NAMES.TRADE_IN]: {
    id: `${intlPrefix}.tradeIn`,
    defaultMessage: 'Inzahlungnahme',
  },
  [VEHICLE_PURCHASE_SERVICES_NAMES.PURCHASE_ADVICE]: {
    id: `${intlPrefix}.purchaseAdvice`,
    defaultMessage: 'Kaufberatung',
  },
  [VEHICLE_PURCHASE_SERVICES_NAMES.LEASING]: {
    id: `${intlPrefix}.leasing`,
    defaultMessage: 'Leasing',
  },
  [VEHICLE_PURCHASE_SERVICES_NAMES.MOPED_SALE]: {
    id: `${intlPrefix}.mopedSale`,
    defaultMessage: 'Mofa (Verkauf)',
  },
  [VEHICLE_PURCHASE_SERVICES_NAMES.MOTORCYCLE_SALE]: {
    id: `${intlPrefix}.motorcycleSale`,
    defaultMessage: 'Motorrad (Verkauf)',
  },
  [VEHICLE_PURCHASE_SERVICES_NAMES.TEST_DRIVE]: {
    id: `${intlPrefix}.testDrive`,
    defaultMessage: 'Probefahrt',
  },
  [VEHICLE_PURCHASE_SERVICES_NAMES.INSURANCES]: {
    id: `${intlPrefix}.insurances`,
    defaultMessage: 'Versicherungen',
  },
});
